import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFailed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.46967 9.46967C9.76256 9.17678 10.2374 9.17678 10.5303 9.46967L12 10.9393L13.4697 9.46967C13.7626 9.17678 14.2374 9.17678 14.5303 9.46967C14.8232 9.76256 14.8232 10.2374 14.5303 10.5303L13.0607 12L14.5303 13.4697C14.8232 13.7626 14.8232 14.2374 14.5303 14.5303C14.2374 14.8232 13.7626 14.8232 13.4697 14.5303L12 13.0607L10.5303 14.5303C10.2374 14.8232 9.76256 14.8232 9.46967 14.5303C9.17678 14.2374 9.17678 13.7626 9.46967 13.4697L10.9393 12L9.46967 10.5303C9.17678 10.2374 9.17678 9.76256 9.46967 9.46967Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.25 12C2.25 6.61389 6.61389 2.25 12 2.25C17.3861 2.25 21.75 6.61389 21.75 12C21.75 17.3861 17.3861 21.75 12 21.75C6.61389 21.75 2.25 17.3861 2.25 12ZM12 3.75C7.44232 3.75 3.75 7.44232 3.75 12C3.75 16.5577 7.44232 20.25 12 20.25C16.5577 20.25 20.25 16.5577 20.25 12C20.25 7.44232 16.5577 3.75 12 3.75Z",
		fill: "currentColor"
	})]
});
export { SvgIconFailed as ReactComponent };
